import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';

function getState() {
    return {};
}

export class WidgetBrief extends React.Component<any, any> {
    //LL: 03.20.25 
    private references: {
        handle?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = _.extend(
            {},

            getState.call(this),

            {}
        );
    }

    getDragHelper = () => {
        let clone = $(this.references.handle).clone();

        clone.removeAttr('data-reactid');

        clone.find('*').each(function () {
            $(this).removeAttr('data-reactid');
        });

        clone.addClass('template-item-helper');

        return clone;
    };

    componentDidMount() {
        $(this.references.handle)
            .draggable({
                helper: this.getDragHelper,
                revert: true,
                revertDuration: 0,
                zIndex: 6,
                addClasses: false,
                appendTo: $('.pdc-platform')
            })
            .data('widgetId', this.props.data.id)
            .data('type', 'widget');
    }

    componentWillUnmount() {
        $(this.references.handle).draggable('destroy');
    }

    render() {
        let constr = WidgetBase.getConstructorByName(this.props.data.type);

        let icon;
        if (constr !== null) {
            icon = <span className={'glyphicon glyphicon-' + constr.icon}></span>;
        }

        return (
            <div 
                ref={(input) => {
                    this.references.handle = input;
                }} //LL: 03.20.25
                className="btn btn-default widget-brief"
            >
                {icon}
                {this.props.data.values[this.props.data.type].name}
            </div>
        );
    }
}
